<template>
  <div>

    <TitlePage :title="$t('promo-codes')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6">
        <v-btn elevation="2" color="secondary" small class="mr-2" :to="pathCreate">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('create') }}
        </v-btn>
      </v-col>

      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler"></ItemActions>
      </v-col>

    </v-row>

    <v-card tile>
      <v-row class="mt-0 pl-4 pr-4 align-center pb-2">
        <v-col cols="12" md="3" class="pt-2 pb-0">
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense outlined></v-text-field>
        </v-col>
        <v-col cols="12" md="3" class="pt-2 pb-0" v-if="getUser.super_admin">
          <CenterSelectSearch
              v-model="filters.center_id"
              :multiple="false"
              :includeAllOption="true"
              autoStrategy="user"
              :returnObject="false"
              @message="(val) => filters.center_id = val"
          />
        </v-col>
        <v-col cols="12" md="6" class="pt-2 pb-0"  v-if="getUser.super_admin">
          <CustomerAutocomplete
              :init-value="filters.user_id"
              @message="(val) => filters.user_id = val"
          />
        </v-col>
        <v-col cols="12" md="2" class="pt-2 pb-0">
          <v-select :items="choices" label="Utilizzato" item-text="text" item-value="value" v-model="filters.used" outlined dense hide-details></v-select>
        </v-col>
        <v-col cols="12" md="2" class="pt-2 pb-0">
          <v-select :items="choices" label="Scaduto" item-text="text" item-value="value" v-model="filters.expired" outlined dense hide-details></v-select>
        </v-col>
        <v-col cols="12" md="2" class="pt-2 pb-0" v-if="getUser.super_admin">
          <v-select :items="type" label="Tipo" item-text="text" item-value="value" v-model="filters.type" outlined dense hide-details></v-select>
        </v-col>
        <v-spacer />
        <v-col cols="12" md="3" class="text-right">
          <v-btn small color="error" @click="resetFilters">
            <v-icon left small>mdi-restore</v-icon> RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-5">
      <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          item-key="_id"
          show-select
          class="elevation-1"
          v-model="selected"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 25, 50, 100]
          }"
      >

        <template v-slot:item.code="{ item }">
          <router-link
              v-if="item._id"
              :to="`/promo-codes/edit/${item._id}`"
          >
            <strong>{{item.code}}</strong>
          </router-link>
        </template>

        <template v-slot:item.num_use="{ item }">
          <span v-if="item.num_use === 0" class="text-uppercase">
            {{ $t('no') }}
          </span>
          <span v-else-if="item.num_use > 0" class="text-uppercase">{{$t('yes')}}</span>
        </template>

        <template v-slot:item.type="{ item }">
          <v-row dense>
            <v-col cols="12" v-if="item.code.includes('PROMO-10')">
              <v-chip small color="secondary" text-color="white">Promo uCamp automatica</v-chip>
            </v-col>
            <v-col cols="12" v-if="item.enable_promo_sa_global">
              <v-chip small color="primary">Promo uCamp</v-chip>
            </v-col>
            <v-col cols="12" v-if="item.enable_promo_center">
              <v-chip small color="warning" text-color="white">Promo Centro sportivo</v-chip>
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.center_name="{ item }">
          <span v-if="item.centers_data && item.centers_data.length > 0" @click="getUser.super_admin ? openCenterDetail(item.centers_data[0]) : ''" :class="getUser.super_admin ? 'text-decoration-underline cursor-pointer' : ''">
            {{ item.centers_data[0].name }}
          </span>
          <span v-else>-</span>
        </template>

        <template v-slot:item.customer_name="{ item }">
          <span v-if="item.customers_data && item.customers_data.length > 0" @click="getUser.super_admin ? openCustomerDetail(item.customers_data[0]) : ''" :class="getUser.super_admin ? 'text-decoration-underline cursor-pointer' : ''">
            {{ item.customers_data[0].name }} {{ item.customers_data[0].surname }}
          </span>
          <span v-else>-</span>
        </template>

        <template v-slot:item.date_start="{ item }">
          {{new Date(item.date_start).toLocaleDateString()}}
        </template>

        <template v-slot:item.date_end="{ item }">
          {{new Date(item.date_end).toLocaleDateString()}}
        </template>

        <template v-slot:item.expired="{ item }">
          <span v-if="new Date() > new Date(item.date_end) && item.num_use === 0" class="text-uppercase">
            {{ $t('yes') }}
          </span>
          <span v-else class="text-uppercase">
            {{ $t('no') }}
          </span>
        </template>

        <template v-slot:item.created_at="{ item }">
          {{new Date(item.created_at).toLocaleString()}}
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon @click="edit(item._id)" :title="$t('edit')" color="primary">mdi-file-edit</v-icon>
          <v-icon @click="confirmRemove(item._id)" :title="$t('delete')" color="primary" v-if="getUser.super_admin">mdi-delete</v-icon>
        </template>

        <template v-slot:item.status_detail="{ item }">
          <v-chip small label v-if="new Date() > new Date(item.date_end) || (item.num_use > 0 && (item.max_use_for_user === item.num_use || item.max_use_generic === item.num_use))" color="red" text-color="white">NON ATTIVO</v-chip>
          <v-chip small label v-else color="green" text-color="white">ATTIVO</v-chip>
<!--          <v-switch v-model="item.status" inset @change="updateSingleStatus(item)" hide-details dense class="mt-0"></v-switch>-->
        </template>

        <template v-slot:item.status="{ item }">
                    <v-switch v-model="item.status" inset @change="updateSingleStatus(item)" hide-details dense class="mt-0"></v-switch>
        </template>

      </v-data-table>
    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import CustomerAutocomplete from "@/components/admin/CustomerAutocomplete.vue";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete.vue";
import CenterSelectSearch from "@/components/filters/CenterSelectSearch.vue";

const exportService = require('@/services/export')

export default {
  name: 'PromoCodes',
  components: {CenterSelectSearch, CenterAutocomplete, CustomerAutocomplete, ItemActions, ModalDelete, TitlePage},
  data() {
    return {
      pathCreate: '/promo-codes/create/',
      pathEdit: '/promo-codes/edit/',
      search: '',
      selected: [],
      baseHeaders: [
        // { text: this.$t('Id'), align: 'start', value: '_id'},
        { text: this.$t('code'), align: 'start', value: 'code'},
        { text: this.$t('type'), align: 'start', value: 'type'},
        { text: this.$t('enabled'), value: 'status', sortable: false},
        { text: this.$t('status'), value: 'status_detail', sortable: false},
        { text: this.$t('used'), align: 'start', value: 'num_use'},
        { text: this.$t('expired'), align: 'start', value: 'expired'},
        { text: this.$t('deadline'), align: 'start', value: 'date_end'},
        { text: this.$t('customer'), value: 'customer_name' },
        { text: this.$t('sportCenter'), value: 'center_name' },
        // { text: 'Data Creazione', value: 'created_at', sortable: true, align: 'start' },
        { text: this.$t('actions'), align: 'start', value: 'action', },
      ],
      choices: [
        {text: "", value: ""},
        {text: this.$t('yes'), value: 'yes'},
        {text: this.$t('no'), value: 'no'},
      ],
      type: [
        {text: "", value: ""},
        {text: 'Promo uCamp', value: 'promo_uCamp'},
        {text: 'Promo uCamp Automatica', value: 'promo_uCamp_auto'},
        {text: 'Promo Centro Sportivo', value: 'promo_center'},
      ],
      items: [],
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['created_at'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
      },
      totalItems: 0,
      loading: false,
      filters: {
        user_id: null,
        center_id: null,
        used: null,
        expired: null,
        type: null,
      },
    };
  },
  async created(){
    if(!this.getUser.super_admin && this.getUser.center_id){
      this.filters.center_id = this.getUser.center_id
    }

    if(this.$route.query.user_id && this.getUser.super_admin){
      this.filters.user_id = this.$route.query.user_id
    }else {
      this.filters.user_id = null
    }

    this._debouncedSearch = this.debounce(async () => { await this.loadData(); }, 350);

  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true
    },
    filters: {
      handler() {
        this._debouncedSearch();
      },
      deep: true
    },
    search: function(){ this._debouncedSearch(); }
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'promoCodes/index',
      'getPaginated': 'promoCodes/getPaginated',
      'updateItem':'promoCodes/update',
      'deleteItem': 'promoCodes/delete',
      'massiveDeleteItem': 'promoCodes/massDelete'
    }),

    debounce(fn, wait){
      var t=null; return function(){ var ctx=this,args=arguments;
        clearTimeout(t); t=setTimeout(function(){ fn.apply(ctx,args); }, wait);
      };
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id){
      this.$router.push(this.pathEdit+id)
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode){
      if(this.typeDelete == 'single'){
        await this.remove(mode)
      }else if(this.typeDelete == 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          await this.loadData();
          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          await this.loadData();
          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async updateSingleStatus(item){

      await this.setLoading(true);
      var result = await this.updateItem({id:item._id, item: {status: item.status}})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    resetFilters() {
      if(this.getUser.super_admin){
        this.filters.user_id = null;
        this.filters.center_id = null;
        this.filters.expired = null;
        this.filters.type = null;
        this.filters.used = null;
      }
      this.search = '';
      this.options.page = 1;
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        const params = {
          page,
          limit: itemsPerPage,
          search: this.search,
          sortBy: sortBy[0] || null,
          sortDesc: sortDesc[0] || false,
          user_id: this.filters.user_id,
          center_id: this.filters.center_id,
          used: this.filters.used,
          expired: this.filters.expired,
          type: this.filters.type,
        };
        const result = await this.getPaginated(params);
        this.items = result.data;
        this.totalItems = result.total;
      } finally {
        this.loading = false;
      }
    },
    openCustomerDetail(customer){
      if(customer._id){
        window.open(`/#/customers/details/${customer._id}`, '_blank');
      }
    },
    openCenterDetail(center){
      if(center._id){
        window.open(`/#/centers?_id=${center._id}`, '_blank');
      }
    },
  },
  mounted() {

  },
  computed: {
    ...mapGetters({
      'getUser':'user/getUser'
    }),
    headers() {
      const isSuperAdmin = this.getUser.super_admin;
      if (!isSuperAdmin) {
        return this.baseHeaders.filter(h => h.value !== 'type');
      }else {
        return this.baseHeaders;
      }

    }
  },
}
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
